import { gtmApi } from '../api';
import { INITIALIZE_GTM, INITIALIZE_GTM_TAG_STEPS, UPDATE_CONTAINER_ID } from './store/gtm.action';

export const initializeGtm = gtmContainerId => async dispatch => {
  await gtmApi.initGtm(gtmContainerId);

  await dispatch({
    type: INITIALIZE_GTM,
  });
};

export const updateContainerId = (gtmContainerId: string) => async dispatch => {
  await dispatch({
    type: UPDATE_CONTAINER_ID,
    payload: gtmContainerId,
  });

  if (gtmContainerId) {
    await dispatch(initializeGtm(gtmContainerId));
  }
};

export const gtmEvent = (eventCategory: string, eventAction: string, eventValue: string) => async (dispatch, getState) => {
  const { containerId } = await getState().gtm;
  const { subscription } = await getState().kubrickManagement;
  if (containerId)
    await gtmApi.gtmEvent(eventCategory, eventAction, subscription ? subscription.subscriptionNumber : undefined, eventValue);
};

export const initializeGtmTagSteps = (gtmTagSteps: Array<string>) => async dispatch => {
  await dispatch({
    type: INITIALIZE_GTM_TAG_STEPS,
    payload: gtmTagSteps,
  });
}

export const refreshClientId = () => {
  gtmApi.refreshClientId();
}
